import { render, staticRenderFns } from "./vedio.vue?vue&type=template&id=7b647047&scoped=true&"
import script from "./vedio.vue?vue&type=script&lang=js&"
export * from "./vedio.vue?vue&type=script&lang=js&"
import style0 from "./vedio.vue?vue&type=style&index=0&id=7b647047&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b647047",
  null
  
)

export default component.exports